"use strict";
/**
 * 通用工具函数
 * 参考 common-send-prize 模块实现
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUid = getUid;
exports.isUserLoggedIn = isUserLoggedIn;
exports.jumpLogin = jumpLogin;
exports.default = useCommon;
/**
 * 获取用户 UID
 * @returns 用户 UID，未登录时返回 0
 */
function getUid() {
    var _a, _b, _c, _d;
    return ((_d = (_c = (_b = (_a = require('@futuweb/fego-render')) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.variable) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.UID) || 0;
}
/**
 * 检查用户是否已登录
 * @returns 是否已登录
 */
function isUserLoggedIn() {
    const uid = getUid();
    return uid > 0;
}
/**
 * 跳转登录页面
 * @param options 可选配置
 */
function jumpLogin(options) {
    const { common: { behavior: { runBehaviour }, }, } = require('@futuweb/fego-render');
    runBehaviour(null, Object.assign({
        type: 'login',
        value: location.href,
        withQuery: true,
    }, options));
}
/**
 * 通用工具 Hook
 * @returns 包含 uid、isLogin、jumpLogin 的对象
 */
function useCommon() {
    const uid = getUid();
    const isLogin = isUserLoggedIn();
    return {
        uid,
        isLogin,
        jumpLogin,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29tbW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7O0dBR0c7O0FBTUgsd0JBRUM7QUFNRCx3Q0FHQztBQU1ELDhCQWtCQztBQU1ELDRCQVNDO0FBdEREOzs7R0FHRztBQUNILFNBQWdCLE1BQU07O0lBQ2xCLE9BQU8sQ0FBQSxNQUFBLE1BQUEsTUFBQSxNQUFBLE9BQU8sQ0FBQyxzQkFBc0IsQ0FBQywwQ0FBRSxLQUFLLDBDQUFFLFFBQVEsMENBQUUsSUFBSSwwQ0FBRSxHQUFHLEtBQUksQ0FBQyxDQUFDO0FBQzVFLENBQUM7QUFFRDs7O0dBR0c7QUFDSCxTQUFnQixjQUFjO0lBQzFCLE1BQU0sR0FBRyxHQUFHLE1BQU0sRUFBRSxDQUFDO0lBQ3JCLE9BQU8sR0FBRyxHQUFHLENBQUMsQ0FBQztBQUNuQixDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsU0FBZ0IsU0FBUyxDQUFDLE9BQWlDO0lBQ3ZELE1BQU0sRUFDRixNQUFNLEVBQUUsRUFDSixRQUFRLEVBQUUsRUFBRSxZQUFZLEVBQUUsR0FDN0IsR0FDSixHQUFHLE9BQU8sQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO0lBRXBDLFlBQVksQ0FDUixJQUFJLEVBQ0osTUFBTSxDQUFDLE1BQU0sQ0FDVDtRQUNJLElBQUksRUFBRSxPQUFPO1FBQ2IsS0FBSyxFQUFFLFFBQVEsQ0FBQyxJQUFJO1FBQ3BCLFNBQVMsRUFBRSxJQUFJO0tBQ2xCLEVBQ0QsT0FBTyxDQUNWLENBQ0osQ0FBQztBQUNOLENBQUM7QUFFRDs7O0dBR0c7QUFDSCxTQUF3QixTQUFTO0lBQzdCLE1BQU0sR0FBRyxHQUFHLE1BQU0sRUFBRSxDQUFDO0lBQ3JCLE1BQU0sT0FBTyxHQUFHLGNBQWMsRUFBRSxDQUFDO0lBRWpDLE9BQU87UUFDSCxHQUFHO1FBQ0gsT0FBTztRQUNQLFNBQVM7S0FDWixDQUFDO0FBQ04sQ0FBQyJ9